module.exports = __webpack_public_path__ + "static/media/service_online_4.38bcbc49.png";